const candidateWarningConstants = {
    TIMED_OUT: 'timed_out',
};

export default candidateWarningConstants;
